<template>
  <div class="approveBox">
    <qx-card title="审核结果">
      <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="customBaseform || baseForm" />
      <SubBtnBox v-if="!inFast" @sub="sub" :customCancel="customCancel" @cancel="cancel" />
      <section class="fastBtnBox">
        <el-button :loading="loading" v-if="inFast" type="primary" @click="sub">确定</el-button>
      </section>
    </qx-card>
    <qx-card title="审核日志" v-show="tableData.data.length > 0">
      <div class="tableBox">
        <el-table :data="tableData.data" tooltip-effect="dark">
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :min-width="item.minW"
            :width="item.w"
          />
        </el-table>
      </div>
    </qx-card>
  </div>
</template>

<script>
import SubBtnBox from 'components/subBtnBox';
import {
  approve,
} from 'api';
export default {
  components: {
    SubBtnBox,
  },
  props: {
    busiId: {
      type: String,
    },
    instId: {
      type: String,
    },
    busiCode: {
      type: String,
    },
    tenantId: {
      type: String,
    },
    customPost: {
      type: Boolean,
      default: false,
    },
    customBaseform: {
      type: Object,
      default: () => (null),
    },
    customCancel: {
      type: Boolean,
      default: false,
    },
    costomSuccess: {
      type: Boolean,
      default: false,
    },
    inFast: {
      type: Boolean,
      default: false,
    },
    // 是否停留在当前页（默认返回第一页）
    stayInCurrentPage: {
      type: Boolean,
      default: false,
    },
    handleRefresh: {
      type: Function,
      default: () => {},
    },
  },
  data () {
    return {
      loading: false,
      baseForm: {
        form: [
          {
            label: '审核结果',
            value: 'chooseResult',
            type: 'radio',
            width: '200px',
            default: 1,
            options: [
              {
                label: '通过',
                value: 1,
              },
              {
                label: '不通过',
                value: 2,
              },
            ],
          },
          {
            label: '审核意见',
            value: 'desc',
            type: 'input',
            width: '430px',
            attr: {
              type: 'textarea',
              limit: 300,
            },
          },
        ],
        rules: {
          chooseResult: [ // 审核结果
            { required: true, message: '请选择审核结果', trigger: 'blur' },
          ],
          // desc: [ // 任务说明
          //   { required: true, message: '', trigger: 'blur' },
          // ],
        },
      },
      tableData: {
        title: [
          {
            prop: 'customerCode',
            label: '序号',
          },
          {
            prop: 'companyName',
            label: '审核人',
          },
          {
            prop: 'companyName',
            label: '审核时间',
          },
          {
            prop: 'companyName',
            label: '审核内容',
          },
        ],
        data: [],
      },
    };
  },
  methods: {
    async sub () {
      const formData = await this.$refs.baseForm.sub();
      if (this.customPost) {
        this.$emit('sub', formData);
        return;
      }
      if (formData) {
        this.loading = true;
        let res = await approve({
          ...formData,
          busiId: this.busiId,
          busiCode: this.busiCode,
          instId: this.instId,
        });
        this.loading = false;
        if (!res.failed && !this.costomSuccess) {
          this.$message({
            type: 'success',
            message: '保存成功',
          });
          if (!this.inFast) {
            if (this.stayInCurrentPage) {
              sessionStorage.setItem('stayInCurrentPage', 'true');
            } else {
              sessionStorage.removeItem('stayInCurrentPage');
            }
            this.close();
          } else {
            this.loading = false;
            this.handleRefresh();
          }
        } else if (!res.failed) {
          this.$emit('success');
        }
      }
    },
    cancel () {
      this.$emit('cancel');
    },
  },
  // created () {
  //   this.tableData.data = [{customerCode: 123}];
  // },
};
</script>

<style scoped lang="scss">
.approveBox {
  padding-bottom: 56px;
}
.fastBtnBox{
  padding-left: 100px;
}
</style>
